import React from "react";
import PropTypes from "prop-types";
import DataGrid from "components/data-grid";

const IconMenu = ({ className, children }) => <DataGrid className={className}>{children}</DataGrid>;

IconMenu.propTypes = {
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
};

export default IconMenu;
